import { ESubscriptionTier } from '__generated__/globalTypes';

export const SUBSCRIPTION_CONFIG = {
    [ESubscriptionTier.FREE]: {
        name: 'Free',
        maxMarkers: 25,
        maxViews: 250,
        maxMaps: 1,
        dedicatedSupport: false
    },
    [ESubscriptionTier.TIER_V1_LEVEL_1]: {
        name: 'Creator',
        maxMarkers: 50,
        maxViews: 2500,
        maxMaps: 5,
        dedicatedSupport: false
    },
    [ESubscriptionTier.TIER_V1_LEVEL_2]: {
        name: 'Pro',
        // null means unlimited
        maxMarkers: null,
        maxMaps: null,
        maxViews: 7500,
        dedicatedSupport: true
    },
    [ESubscriptionTier.FULL]: {
        name: 'Full',
        // null means unlimited
        maxMarkers: null,
        maxMaps: null,
        maxViews: 999999,
        dedicatedSupport: true
    }
};
